import type { RootState } from '@store/types';

import type { WaitingRoomState } from './slice';
import { waitingRoomEntrySelectors } from './slice';

const emptyWaitingRoomState: WaitingRoomState = {
  ids: [],
  entities: {},
  providerAvailability: 'offline',
  link: null,
  sseConnectionState: 'idle',
  error: null,
  lastSnapshotAt: null,
  lastEventAt: null,
};

export const selectWaitingRoomState = (state: RootState): WaitingRoomState =>
  state.waitingRoom ?? emptyWaitingRoomState;

export const selectWaitingRoomEntries = (state: RootState) =>
  waitingRoomEntrySelectors.selectAll(selectWaitingRoomState(state));

export const selectWaitingRoomEntryById = (state: RootState, entryId: string) =>
  waitingRoomEntrySelectors.selectById(selectWaitingRoomState(state), entryId);

export const selectWaitingRoomProviderAvailability = (state: RootState) =>
  selectWaitingRoomState(state).providerAvailability;

export const selectWaitingRoomLink = (state: RootState) => selectWaitingRoomState(state).link;

export const selectWaitingRoomSseConnectionState = (state: RootState) =>
  selectWaitingRoomState(state).sseConnectionState;

export const selectWaitingRoomError = (state: RootState) => selectWaitingRoomState(state).error;

export const selectWaitingRoomLastSnapshotAt = (state: RootState) =>
  selectWaitingRoomState(state).lastSnapshotAt;
